module.exports = __webpack_public_path__ + "img/perfil-del-usuario.5334e928.png";